import { useState } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as CopyIcon } from 'assets/copy-icon.svg';
import { ReactComponent as CopyIconCard } from 'assets/copy-icon-card.svg';
import './ClipBoard.scss';

export const ClipBoard = ({ isCardComponent = false, copyText }) => {
  const [showCopyNotification, setShowCopyNotification] = useState(false);

  const copyToClipBoard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setShowCopyNotification(true);
      setTimeout(() => {
        setShowCopyNotification(false);
      }, 2000);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('failed to copy from clipboard:', err);
    }
  };

  return (
    <div className='clipboard-wrapper'>
      {isCardComponent ? (
        <CopyIconCard className='clipboard-icon' onClick={() => copyToClipBoard(copyText)} />
      ) : (
        <CopyIcon className='clipboard-icon' onClick={() => copyToClipBoard(copyText)} />
      )}

      {showCopyNotification && (
        <div className='clipboard-notification'>
          <p>Field copied</p>
        </div>
      )}
    </div>
  );
};

ClipBoard.propTypes = {
  isCardComponent: PropTypes.bool,
  copyText: PropTypes.string
};
